export default __webpack_public_path__ + "static/media/ivan1.e1357766.jpg";